import { createContext, useReducer } from 'react';
import reducer from './ComponentsReducer';

const initialState = {
    components: [],
    contextMenuOffset: {},
    selectedComponentIndex: "0",
    deletedComponentIndex: "",
    contextMenuItemIndex: "",
    showAddComponentDialog: false,
    showEditComponentDialog: false,
    showDeleteComponentDialog: false,
    showContextMenu: false,
    showComponentEnableDisableDialog: false,
    showResetComponentDialog: false
}

const ComponentsContext = createContext();

export function ComponentsContextProvider({ children }) {

    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <ComponentsContext.Provider
            value={{
                state,
                dispatch
            }}
        >
            {children}
        </ComponentsContext.Provider>
    )
}

export default ComponentsContext;